import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box } from '@mui/material';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';

interface QuotaExceededDialogProps {
  open: boolean;
  message: string;
  onClose: () => void;
}

const QuotaExceededDialog: React.FC<QuotaExceededDialogProps> = ({ open, message, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <ErrorOutlineRoundedIcon sx={{ color: 'error.main' }} />
          <Typography variant="h6" component="span">
            Quota Limit Reached
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1">{message}</Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="error" onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default QuotaExceededDialog;
